// Internal Imports
import { deleteApi, get, post, put } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";
import { QuotesUtils } from "../../utils";
import store from "../../store";

// Destructuring
const { APIS } = API_ENDPOINTS;

/*
==========================================
        Quotes Functions
==========================================
*/

const addQuote = quote =>
  new Promise((resolve, reject) => {
    console.debug(APIS.QUOTES);
    post(`${APIS.QUOTES}`, quote)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

const deleteDocumentRequest = docID =>
  new Promise((resolve, reject) => {
    console.debug(APIS.QUOTES);
    deleteApi(`${APIS.QUOTES}/${docID}`)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

const deleteQuoteRequest = quoteID =>
  new Promise((resolve, reject) => {
    console.debug(APIS.QUOTES);
    deleteApi(`${APIS.QUOTES}/${quoteID}`)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

const fetchAllQuotesByUser = () =>
  new Promise((resolve, reject) => {
    get(APIS.QUOTES)
      .then(res => {
        const quotesList = {};
        quotesList.data = res.Quotes;
        quotesList.statusData = QuotesUtils.prepareQuoteStatusCount(res.Quotes);
        resolve(quotesList);
      })
      .catch(err => {
        reject(err);
      });
  });

const generateQuoteNo = () =>
  new Promise((resolve, reject) => {
    post(APIS.GET_QUOTE_ID)
      .then(res => {
        console.debug(res);
        resolve(res.QuoteNumber);
      })
      .catch(err => {
        reject(err);
      });
  });

const generateDocumentID = type =>
  new Promise((resolve, reject) => {
    post(`${APIS.GET_DOCTYPE_ID}/${type}`)
      .then(res => {
        resolve(res.document_id);
      })
      .catch(err => {
        reject(err);
      });
  });
/*
==========================================
        Quote Approval Functions
==========================================
*/

const sendQuoteForApprovalRequest = quoteID =>
  new Promise((resolve, reject) => {
    const payload = {
      comment: "Please approve this quote",
      additional_reviewers: [],
    };
    post(`${APIS.QUOTES}/${quoteID}/approval`, payload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

const approveQuoteRequest = quoteID =>
  new Promise((resolve, reject) => {
    const payload = {
      comment: "approved",
    };
    post(`${APIS.APPROVALS}/objects/quote/${quoteID}/approve`, payload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

const rejectQuoteRequest = quoteID =>
  new Promise((resolve, reject) => {
    const payload = {
      comment: "rejected",
    };
    post(`${APIS.APPROVALS}/objects/quote/${quoteID}/reject`, payload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

/*
==========================================
        Quotes Details Functions
==========================================
*/
const fetchQuoteDetails = id =>
  new Promise((resolve, reject) => {
    get(`${APIS.QUOTES}/${id}`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

/*
==========================================
            Quoteterm Functions
==========================================]
*/

const fetchDefaultTemplate = () => "";

const saveQuotermFormFields = data => {
  console.debug(data);
};

const fetchQuotetermByQuoteID = quoteID =>
  new Promise((resolve, reject) => {
    get(`${APIS.QUOTES}/${quoteID}/terms`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

const fetchQuotetermTemplateByID = id =>
  new Promise((resolve, reject) => {
    get(`${APIS.QUOTETERM_TEMPLATES}/${id}`)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

const saveQuotetermFormFields = () =>
  new Promise((resolve, reject) => {
    const state = store.getState().QuotesStore;
    const template = state.quotetermTemplate;
    const formFields = state.quotetermFormFields || [];

    const { quoteID } = template;
    const templateID = template.id;

    if (!(templateID && quoteID)) {
      reject(new Error("Template ID or Quote ID Not Defined"));
    } else {
      const fieldValues = {};
      formFields.forEach(item => {
        // if (item.value === undefined || item.value === "") {
        //   inCompleteForm = true;
        // }
        fieldValues[item.id] = item.value;
      });
      const payload = {
        quote_id: quoteID,
        template_id: templateID,
        field_values: fieldValues,
      };
      put(`${APIS.QUOTES}/${quoteID}/terms`, payload)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    }

    // Need for later
    // let inCompleteForm = false;
    // if (template.fieldForms.length !== formFields.length) {
    //   inCompleteForm = true;
    // }
    // if (inCompleteForm) {
    //   reject("Forms not saved! Kindly review the form.");
    // } else {
    // }
  });

// Fetch Deal Term Templates
const fetchQuotetermTemplateList = () =>
  new Promise((resolve, reject) => {
    get(APIS.QUOTETERM_TEMPLATES)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

const saveQuoteTermTemplate = template =>
  new Promise((resolve, reject) => {
    put(`${APIS.QUOTETERM_TEMPLATES}`, template)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

const deleteQuoteTermTemplate = id =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.QUOTETERM_TEMPLATES}/${id}`)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

/*
==========================================
            Catalog Functions
==========================================
*/
const fetchAllPriceLists = () =>
  new Promise((resolve, reject) => {
    get(APIS.PRICE_LISTS)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

const fetchCatalogs = (pricelistID, value, categoryID) =>
  new Promise((resolve, reject) => {
    // const categoryQuery = categoryID !== 0 ? `&family_id=${categoryID}` : "";
    const categoryQuery =
      categoryID !== "All Product Types" && categoryID !== 0
        ? `&product_type=${categoryID}`
        : "";
    get(`${APIS.CATALOGS}/${pricelistID}/items?text=${value}${categoryQuery}`)
      .then(res => {
        const addedCatalogIds = store.getState().QuotesStore
          .catalogItemsAddedToDealTable;
        QuotesUtils.formatProductItems(res, addedCatalogIds);
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

const fetchCategories = async () => {
  const products = await get(`${APIS.CATEGORIES}`)
    .then(res => res)
    .catch(error => {
      throw error;
    });
  console.debug(products);
  return products;
};

export const getProductFamilies = async () => {
  const families = await get(`${APIS.PRODUCT_FAMILIES}`)
    .then(res => res)
    .catch(error => {
      throw error;
    });
  return families;
};

const updateCatalogItem = (ids, flag, type) => {
  const state = store.getState().QuotesStore.catalogItems;
  const catalogItems = state.map(item => {
    if (ids.includes(item.id)) {
      if (!type) {
        return { ...item, isDisabled: flag, isChecked: flag };
      }
      return { ...item, [type]: flag };
    }
    return item;
  });
  return catalogItems;
};

export {
  addQuote,
  approveQuoteRequest,
  deleteDocumentRequest,
  deleteQuoteRequest,
  deleteQuoteTermTemplate,
  fetchAllPriceLists,
  fetchAllQuotesByUser,
  fetchCatalogs,
  fetchCategories,
  fetchDefaultTemplate,
  fetchQuoteDetails,
  fetchQuotetermByQuoteID,
  fetchQuotetermTemplateByID,
  fetchQuotetermTemplateList,
  generateDocumentID,
  generateQuoteNo,
  rejectQuoteRequest,
  saveQuoteTermTemplate,
  saveQuotermFormFields,
  saveQuotetermFormFields,
  sendQuoteForApprovalRequest,
  updateCatalogItem,
};



// WEBPACK FOOTER //
// ./src/actions/QuotesActions/QuotesService.js